module.exports = "/_next/static/images/jupiter-49419c72eae44ae35806cdd67442a2d3.png";